exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editor-slide-upload[data-v-b11494f6]{margin-bottom:20px}.editor-slide-upload[data-v-b11494f6] .el-upload--picture-card{width:100%}\n", ""]);

// exports
